import React, { useEffect as UseEffect } from "react";
import { useLocation as UseLocation } from 'react-router-dom';
import { useNavigate as UseNavigate } from "react-router-dom";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import TokenService from "../../../services/security/token.service";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box'
import AccessibilityIcon from '@mui/icons-material/Accessibility';
import AuthService from "../../../services/security/auth.service";

const listLogin = () => {
    let navigate = UseNavigate();
    const location = UseLocation()
    const params = new URLSearchParams(location.search)
    let dataParam = params.get("data");

    UseEffect(() => {
        document.title = `wBroker`;
    })

    const data = JSON.parse(decodeURIComponent(dataParam));

    const defaultTheme = createTheme();
    const handleCheckboxChange = (event, instance, item, email, client) => {
        const isChecked = event.target.checked;

        if (isChecked) {

            let dataUser = TokenService.getUser();
            dataUser.data = item;
            dataUser.data.instance = instance;
            TokenService.setUser(dataUser);

            AuthService.addLogin(email, null, null, client, item.role, instance, item.entityId).then
                ((response) => {
                    console.log('response1-> ' + JSON.stringify(response))

                    let landingPage = item.landingPage;
                    if (landingPage)
                        navigate(`/${landingPage}`);
                    else
                        navigate(`/home`);
                })
        }
    };

    return (
        <ThemeProvider theme={defaultTheme}>
            <Container component="main" maxWidth="100%">
                <CssBaseline />
                <Box
                    sx={{
                        marginTop: 4,
                        display: 'flex',
                        flexDirection: 'column',
                        //alignItems: 'center',
                    }}
                >
                    <Avatar sx={{ m: 1, bgcolor: 'blue' }}>
                        <AccessibilityIcon />
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        Selección de Perfil
                    </Typography>
                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 650, height: '100%' }} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Seleccione</TableCell>
                                    <TableCell>Compañía</TableCell>
                                    <TableCell>Instancia</TableCell>
                                    <TableCell>Cuenta Comitente</TableCell>
                                    <TableCell>Perfil</TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {data.instances.map((instancias, index) => {
                                    return instancias.roles.map((item, subIndex) => {

                                        return (
                                            <TableRow key={`row_${index}_${subIndex}`}>
                                                <TableCell>
                                                    <input type="checkbox" onChange={(event) => handleCheckboxChange(event, instancias.name, item, data.email, data.client)} />
                                                </TableCell>
                                                <TableCell>{item.company}</TableCell>
                                                <TableCell>{instancias.name}</TableCell>
                                                <TableCell>{item.tradeAccount}</TableCell>
                                                <TableCell>{item.entityProp}</TableCell>
                                            </TableRow>
                                        )
                                    })
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </Container>
        </ThemeProvider>
    );
}

export default listLogin



